<form *ngIf="stepForm"
      id="step-form"
      [formGroup]="stepForm"
      class="form-full with-tabs">
    <div>
        <div class="title">
            <aa-input-text2 name="title"
                            required
                            label="{{ 'ITSM.CREATECASEPOPIN.TITLE' | translate }}"
                            [formControlName]="titleField">
            </aa-input-text2>
        </div>
        <div class="form-header">
            {{ 'ITSM.CREATECASEPOPIN.URGENCY' | translate }}
        </div>
        <div class="urgency">
            <aa-radio-group3 [formControlName]="urgencyIdField"
                             [orientation]="'horizontal'"
                             [name]="urgencyIdField"
                             [options]="urgencyOptions"
                             [marginTop]="0"
                             [required]="'required'">
            </aa-radio-group3>
        </div>
        <div class="form-header category">
            {{ 'ITSM.CREATECASEPOPIN.CATEGORY' | translate }}
        </div>
        <div>
            <aa-input-treeview2 #inputTreeview
                                [formControlName]="catalogEntryField"
                                [treeModel]="this.catalog | async"
                                [name]="catalogEntryField"
                                [height]="200">
            </aa-input-treeview2>
        </div>
    </div>
</form>
